/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    byId: {},
    allIds: [],
    licensesSynthesis: [],
}

const LicensesSlice = createAppSlice({
    name: 'gdl/licenses',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        create: create.asyncThunk(
            async (license, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.licenses(), { body: license, method: 'POST' })
                    toast.success('Licence créée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'une licence')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        update: create.asyncThunk(
            async (license, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.licenses(), { body: license, method: 'PUT' })
                    toast.success('Licence modifiée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification d\'une licence')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        delete: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.license(id), { method: 'DELETE' })
                    toast.success('Licence supprimé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'une licence')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        fetch: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.gdl.licenses())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des licences')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    const byId = keyBy(action.payload, 'id')
                    state.byId = byId
                    state.allIds = action.payload.map(license => license.id)
                },
                options: {
                    condition: (_, { getState }) => {
                        const { gdl } = getState()
                        return gdl.licenses.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            }
        ),
        fetchLicensesSyntesis: create.asyncThunk(
            async (customerId, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.gdl.licensesSynthesis(customerId))
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement de la synthèse des licences')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    state.licensesSynthesis = action.payload
                },
            }
        ),
    }),
    selectors: {
        selectLicenses: (state) => state.allIds.map(id => state.byId[id]),
    },
})

export const LicensesActions = LicensesSlice.actions
export const {
    selectLicenses,
} = LicensesSlice.getSelectors((state) => state.gdl.licenses)
export default LicensesSlice